export default (context) => 'Please respond exclusively in German unless another language is explicitly requested in the prompt.';
//# sourceMappingURL=language.js.map